import React, { useState } from 'react';
import { SectionShell, NumField, TextAreaField, saveSection } from './shared';

export function QaQcEditor({ data, dept, deptLabel, onSaved, projectId, date, readOnly }) {
  const [conducted, setConducted] = useState(data.inspections_conducted ?? 0);
  const [passed, setPassed] = useState(data.inspections_passed ?? 0);
  const [ncrs, setNcrs] = useState(data.ncrs_raised ?? 0);
  const [notes, setNotes] = useState(data.qa_notes || '');
  const [tests, setTests] = useState(data.test_results_summary || '');
  const [saving, setSaving] = useState(false);

  const save = () => saveSection(projectId, date, dept, {
    inspections_conducted: parseInt(conducted, 10) || 0,
    inspections_passed: parseInt(passed, 10) || 0,
    ncrs_raised: parseInt(ncrs, 10) || 0,
    qa_notes: notes,
    test_results_summary: tests,
  }, onSaved, deptLabel, setSaving);

  return (
    <SectionShell deptLabel={deptLabel} dept={dept} onSave={save} saving={saving} readOnly={readOnly}>
      <div className="grid grid-cols-3 gap-3">
        <NumField label="Inspections conducted" value={conducted} onChange={setConducted} testid="dpr-qa-conducted" />
        <NumField label="Inspections passed" value={passed} onChange={setPassed} testid="dpr-qa-passed" />
        <NumField label="NCRs raised today" value={ncrs} onChange={setNcrs} testid="dpr-qa-ncrs" />
      </div>
      <TextAreaField label="QA notes" value={notes} onChange={setNotes} rows={2} testid="dpr-qa-notes" />
      <TextAreaField label="Test results / observations" value={tests} onChange={setTests} rows={2} testid="dpr-qa-tests" />
    </SectionShell>
  );
}
